import { Redirect, Switch, useRouteMatch } from 'react-router-dom';
import { ActivationInterstitial } from './ActivationInterstitial';
import { DataHygienePhoneNumbers } from 'assets/js/pages/contacts/data-hygiene/DataHygienePhoneNumbers';
import { Route } from 'components/router/Route';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const DataHygienePhoneNumbersRouter = () => {
    const match = useRouteMatch();
    const { accountId, dataHygiene, hasGivebutterPlusAccess } = useCurrentAccount();
    const isActivated = dataHygiene?.activated_at !== null;

    if (!hasGivebutterPlusAccess) {
        return <Redirect to={`/accounts/${accountId}/upgrade`} />;
    }

    if (!isActivated) {
        return <ActivationInterstitial />;
    }

    return (
        <Switch>
            <Route path={match.path} component={DataHygienePhoneNumbers} />
        </Switch>
    );
};

export { DataHygienePhoneNumbersRouter };
